module.exports = __webpack_public_path__ + "media/src/application/media/rooms/many_function2-0cb308f12905768997a19ec414d5f86f.png";